import { Component, Output, Input, EventEmitter } from '@angular/core';

@Component({
    selector: 'app-import-csv-btn',
    templateUrl: './import-csv-btn.component.html',
    styleUrls: ['./import-csv-btn.component.scss'],
    standalone: true
})
export class ImportCsvBtnComponent {

  /** flag for tooltip */
  @Input() showTooltip = true;
  /** button text to display */
  @Input() buttonText = 'Cargar .csv';
  /** style for the button */
  @Input() btnStyleClasses = 'btn-info btn-sm text-bold-300 px-1 py-1';
  /** name of the input element */
  @Input() name: string;
  /** type of files accepted */
  @Input() accept = '.csv';

  /** event on send file */
  @Output() sendCsvFile = new EventEmitter();

  /** content of the CSV file */
  csvContent: string;

  constructor() {
  }

  /** Open user's file browser */
  openFileBrowser(event: any): void {
    event.preventDefault();
    const element: HTMLElement = document.getElementById(this.name) as HTMLElement;
    element.click();
  }

  onFileSelect(input: HTMLInputElement) {
    const files = input.files;
    const content = this.csvContent;

    if (files && files.length) {
      const file: File = files.item(0);
      const reader: FileReader = new FileReader();
      reader.readAsText(file);
      reader.onload = (e) => {
        const csv = reader.result as string;
        this.sendCsvFile.emit(csv);
      };
    }
  }

}
